module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Teilnahme ro.3b8a1628.svg";